import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import Modal from 'app/components/Modal';
import modalStyles from 'shared/components/modalStyles';
import KioskService from 'app/services/KioskService';
import WarningIcon from '@mui/icons-material/Warning';

import {
    getStripeReaders,
    setDefaultStripeReader
} from 'app/actions/kioskActions';

const styles = () => ({
    ...modalStyles()
});

const StripeReadersDialog = (props) => {
    const [data, setData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const { settings, isOpen, onClose, classes, setDefaultStripeReader, defaultStripeReader } = props;

    useEffect(() => {
        if (!loaded) {
            props.getStripeReaders(settings.token).then((results) => {
                setData(results);
                setOrigData(results);
                setLoaded(true);
            })
        }
    }, [loaded])

    const enableReader = async (reader) => {
        const objReader = Object.assign({}, reader);
        const _data = [...data];

        const readerIndex = data.indexOf(reader);
        objReader.stripe_reader_enabled = !objReader.stripe_reader_enabled;
        if (!objReader.stripe_reader_enabled) {
            objReader.is_default_reader = false;
        }
        _data[readerIndex] = objReader;

        let connected = false;
        if (objReader.stripe_reader_enabled) {
            let readerParams = {
                location_id: objReader.stripe_reader_location_id,
                registration_code: objReader.stripe_reader_code,
                reader_label: objReader.stripe_reader_label,
            }

            const result = await KioskService.registerStripeReader(settings.account_id, readerParams).then((resp) => {
                objReader.stripe_reader_id = resp.id;
                connected = true;
            }).catch(err => {
                connected = false;
            });
        }

        if (!connected && objReader.stripe_reader_enabled) {
            alert('Unable to enabled the reader. Device is not connected');
            return;
        }

        await KioskService.updateStripeReader(settings.token, objReader.id, objReader).then(() => {
            setData(_data);
            alert('Reader successfully updated');
        })
    }

    const setDefaultReader = async (reader) => {
        const objReader = Object.assign({}, reader);
        await setDefaultStripeReader(objReader).then(() => {
            const _data = [...data];
            const readerIndex = data.indexOf(reader);
            objReader.is_default_reader = !objReader.is_default_reader;
            _data[readerIndex] = objReader;
            _data.forEach((item, index) => {
                if (readerIndex !== index)
                    item.is_default_reader = false;
            })
            setData(_data);
            alert('Reader successfully updated');
        })
    }

    const addNewReader = () => {
        const readers = [...data];
        readers.push({
            stripe_reader_id: '',
            stripe_reader_label: '',
            stripe_reader_code: '',
            stripe_reader_enabled: false
        });
        setData(readers);
    }

    const statusBodyTemplate = (rowData) => {
        return rowData.stripe_reader_enabled ? 'Enabled' : 'Disabled';
    }

    const actionBodyTemplate = (rowData) => {
        let buttons = []
        if (rowData.id) {
            if (defaultStripeReader?.id !== rowData.id && rowData.stripe_reader_enabled) {
                buttons.push(<button className={classes.modalButton} onClick={() => setDefaultReader(rowData)}>Make Default</button>)
            }

            if (!rowData.stripe_reader_enabled) {
                buttons.push(<button className={classes.modalButton} onClick={() => enableReader(rowData)}>Connect</button>)
            }

            buttons.push(<button className={classes.modalButton} style={{ minWidth: '105px' }}onClick={() => removeReader(rowData)}>Remove</button>)
        } else {
            buttons.push(<WarningIcon sx={{ color: 'red', fontSize: '1.5em', float: 'right' }} />)
        }

        return (
            <div className={classes.modalButtons}>
                {buttons}
            </div>
        )
    }


    const isDefaultReaderBodyTemplate = (rowData) => {
        const strReader = localStorage.getItem('defaultStripeReader');
        if (!strReader) {
            return 'No';
        }
        const objReader = JSON.parse(strReader);
        return objReader && objReader.id === rowData.id ? 'Yes' : 'No';
    }

    const onRowEditComplete = (e) => {
        let readers = [...data];
        let { newData, index } = e;

        readers[index] = newData;

        setData(readers);
    };

    const onSubmit = async () => {
        for (let item of data) {
            item.kiosk_id = settings.kiosk_id;
            if (item.id > 0) {
                await KioskService.updateStripeReader(settings.token, item.id, item);
            } else {
                await KioskService.createStripeReader(settings.token, item);
                setLoaded(false);
            }
        }
    }

    const removeReader = (reader) => {
        const readers = [...data];
        KioskService.deleteStripeReader(settings.token, reader.id).then(() => {
            readers.splice(readers.indexOf(reader), 1);
            setData(readers);
        });
    }

    const textEditor = (options) => {
        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
    };

    const renderSlide = () => {
        let slide = {};
        slide.skipClose = true;
        slide.component = <div>
            <DataTable value={data} editMode="row" onRowEditComplete={onRowEditComplete}>
                <Column field='stripe_reader_code' header='Reader Code' editor={(options) => textEditor(options)}></Column>
                <Column field='stripe_reader_label' header='Reader Label' editor={(options) => textEditor(options)}></Column>
                <Column field='stripe_reader_location_id' header='Location ID' editor={(options) => textEditor(options)}></Column>
                <Column field='stripe_reader_enabled' header='Enabled' body={statusBodyTemplate}></Column>
                <Column field='is_default_reader' header='Is Default' body={isDefaultReaderBodyTemplate}></Column>
                <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center', color: 'black' }}></Column>
                <Column body={actionBodyTemplate}></Column>
            </DataTable>
        </div>

        slide.buttons = [];
        slide.buttons.push({
            nextLabel: 'ADD NEW',
            onNext: () => addNewReader()
        })
        slide.buttons.push({
            nextLabel: 'SAVE',
            onNext: () => onSubmit()
        })
        slide.buttons.push({
            nextLabel: 'CLOSE',
            onNext: () => onClose()
        })
        return slide;
    }

    var slides = [];
    slides.push(renderSlide());
    return <Modal slides={slides} open={isOpen} onClose={() => { setLoaded(false); onClose() }} />;
}

const mapStateToProps = state => ({
    settings: state.kioskReducer.settings,
    user: state.kioskReducer.user,
    stripeReaders: state.kioskReducer.stripeReaders,
    defaultStripeReader: state.kioskReducer.defaultStripeReader
});

export default connect(mapStateToProps, { getStripeReaders, setDefaultStripeReader })(withStyles(styles)(StripeReadersDialog));